const s = {
  xs: "d-chip__label--xs",
  sm: "d-chip__label--sm",
  md: ""
}, _ = {
  xs: "d-chip__close--xs",
  sm: "d-chip__close--sm",
  md: ""
}, c = {
  xs: "200",
  sm: "200",
  md: "200"
}, I = {
  CHIP_SIZE_MODIFIERS: s,
  CHIP_CLOSE_BUTTON_SIZE_MODIFIERS: _,
  CHIP_ICON_SIZES: c
};
export {
  _ as CHIP_CLOSE_BUTTON_SIZE_MODIFIERS,
  c as CHIP_ICON_SIZES,
  s as CHIP_SIZE_MODIFIERS,
  I as default
};
//# sourceMappingURL=chip-constants.js.map
